import * as React from "react";
import { LucideIcon } from "lucide-react";

import { cn } from "@/lib/utils";

interface Props {
  icon: LucideIcon;
  iconClassName?: string;
  title: string;
  action?: React.ReactNode;
  children?: React.ReactNode;
}

export const DetailSection: React.FC<Props> = ({ icon: Icon, iconClassName, title, action, children }) => (
  <section className="flex flex-col gap-3">
    <div className="flex min-h-6 items-center justify-between gap-2">
      <h2 className="m-0 flex items-center gap-1.5 text-sm font-semibold text-slate-800">
        <Icon className={cn("size-4.5", iconClassName)} />
        {title}
      </h2>
      {action}
    </div>
    {children && (
      <div className="flex flex-col gap-4 rounded-xl border border-slate-200 bg-slate-50/50 p-5">{children}</div>
    )}
  </section>
);
